/* eslint-disable */

/**
 * ⚠️ This is not owned or maintained by the Arcade team.
 * Please refer to the official Arcade design system for supported and maintained components.
 *
 * An element representing spacing and separators between sections
 */
export interface BetweenSection {
  /** if not provided, `LARGE` will be used and an error will be logged */
  variant?: BetweenSectionVariant;
}

export enum BetweenSectionVariant {
  CLIENT_COULD_NOT_PARSE_SECTION_HEADER_VARIANT = "CLIENT_COULD_NOT_PARSE_SECTION_HEADER_VARIANT",
  /** LARGE - A large height spacer that does not contain a divider */
  LARGE = "LARGE",
  /** X_LARGE - An extra large height spacer containing a divider. */
  X_LARGE = "X_LARGE",
  /** X_LARGE_BELOW_CELL - An extra large height spacer containing a divider with uneven vertical margins. Intended to be used below a cell */
  X_LARGE_BELOW_CELL = "X_LARGE_BELOW_CELL",
}
